import ApiClient from "./ApiClient";

// Cigna Global Health Option's rate file is split across ~120 sheets and is
// processed by a dedicated backend controller/route group - everything else
// (listing, notes) still goes through the generic /insurer_rates endpoints.
export const CGHO_INSURER_ID = 'cigna_global_health_option_rates';

export const uploadFile = ({ body, token }) => {
  return ApiClient.post('/api/insurer_rates/upload_new_rates', body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const uploadNewRates = ({ body, token }) => {
  return ApiClient.post('/api/insurer_rates/upload_new_rates', body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}


export const updateRates = ({ id, body, token }) => {
  return ApiClient.post('/api/insurer_rates/update_rates/' + id, body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const reuploadRates = ({ body, token, insurerRateId }) => {
  return ApiClient.post('/api/insurer_rates/reupload_rates/' + insurerRateId, body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const updateNotes = ({ body, token, insurerRateId }) => {
  return ApiClient.post('/api/insurer_rates/update_notes/' + insurerRateId, body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const fetchNotes = ({ token, insurerRateId }) => {
  return ApiClient.get('/api/insurer_rates/get_notes/' + insurerRateId, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const deleteRates = ({ id, token }) => {
  return ApiClient.delete('/api/insurer_rates/delete_rates/' + id, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}


export const fetchInsurerRates = ({  token }) => {
  return ApiClient.get('/api/insurer_rates', {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const downloadFile = ({ id, token }) => {
  return ApiClient.get('/api/insurer_rates/download_rates?id=' + id, {
    headers: {
      'Authorization': 'Bearer ' + token
    },
    responseType: 'blob'
  })
}

export const uploadNewRatesCGHO = ({ body, token }) => {
  return ApiClient.post('/api/insurer_rates_cgho/upload_new_rates', body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const updateRatesCGHO = ({ id, body, token }) => {
  return ApiClient.post('/api/insurer_rates_cgho/update_rates/' + id, body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const reuploadRatesCGHO = ({ body, token, insurerRateId }) => {
  return ApiClient.post('/api/insurer_rates_cgho/reupload_rates/' + insurerRateId, body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const deleteRatesCGHO = ({ id, token }) => {
  return ApiClient.delete('/api/insurer_rates_cgho/delete_rates/' + id, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const downloadFileCGHO = ({ id, token }) => {
  return ApiClient.get('/api/insurer_rates_cgho/download_rates?id=' + id, {
    headers: {
      'Authorization': 'Bearer ' + token
    },
    responseType: 'blob'
  })
}